import script from "./PopupPromo.vue?vue&type=script&setup=true&lang=ts"
export * from "./PopupPromo.vue?vue&type=script&setup=true&lang=ts"

import "./PopupPromo.vue?vue&type=style&index=0&id=45a5dce2&scoped=true&lang=sass"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45a5dce2"]])

export default __exports__